import Link from 'next/link';
import { FC, ReactNode } from 'react';
import { IoChevronForward } from 'react-icons/io5';

import { Box, Text } from '@mantine/core';

import { PermissionCompany } from 'models';

import { ProfileSectionHelpers } from 'components/company-profile/helpers/ProfileSectionHelpers';
import { useProfilePermission } from 'components/company-profile/hooks/use-profile-permission';
import { useResponsiveNbCols } from 'components/section/useResponsiveNbCols';

import cx from './SparseSectionPanel.module.scss';

type PanelContent = {
    icon: ReactNode;
    title: string;
    description: string;
    cta: string;
    href: string;
};

const SparseSectionPanel: FC<{ owner: PanelContent; visitor: PanelContent }> = ({ owner, visitor }) => {
    const canEdit = useProfilePermission(PermissionCompany.EDIT);

    const { icon, title, description, cta, href } = canEdit ? owner : visitor;

    return (
        <Box component={Link} href={href} className={cx.panel}>
            <Box className={cx.icon}>{icon}</Box>
            <Text className={cx.title}>{title}</Text>
            <Text className={cx.description}>{description}</Text>
            <Text className={cx.cta}>
                {cta}
                <IoChevronForward />
            </Text>
        </Box>
    );
};

const useIsSparseSection = (itemCount: number) => {
    const shownCols = useResponsiveNbCols(0, ProfileSectionHelpers.cols) ?? 1;

    return itemCount < shownCols;
};

export { SparseSectionPanel, useIsSparseSection };
